export default __webpack_public_path__ + "static/media/Bhartiya.bc6b0828.jpeg";